import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "button", "source", "status" ]

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.value)
      this.statusTarget.textContent = "Prompt kopiert."
      this.buttonTarget.textContent = "Kopiert"
    } catch (_error) {
      this.sourceTarget.focus()
      this.sourceTarget.select()
      this.statusTarget.textContent = "Prompt ist markiert. Bitte mit Strg+C oder ⌘C kopieren."
    }
  }
}
